//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SketchOperationBuilder.js";
import "../no/ugmath.js";
let d=[[[0,"SnapEnabled",1,0],[0,"SnapRadius",1,0]],[[["previewGeometryCount"],"GetPreviewGeometry",{R_:{previewGeometry:"NXObject[]"}},0,0],[["snapTarget"],"SetSnapTarget",{},1,0],[["snapTarget","snapHelpPoint"],"SetSnapPointTarget",{},2,0],[[],"LockDirectionalSnapRelations",{},0,0],[[],"UnlockDirectionalSnapRelations",{},0,0],[["index","direction"],"SetDirectionAtTarget",{},2,0],[[],"GetRelationStatus",{R_:{status:''}},0,0],[[],"Reset",{},0,0],[["numRelations"],"GetSnapRelations",{R_:{snapRelations:"SketchFoundRelation[]"}},0,0]],[]];
SPLM.SketchGeometryBuilder = class extends SPLM.SketchOperationBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SketchGeometryBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.SketchGeometryBuilder.RelationStatus = Object.freeze({
    "Free" : "Free", "Sliding" : "Sliding", "DirectionLocked" : "DirectionLocked"});

export default SPLM;